import Service from "../../services";
import { checkAndReturn } from "../../main";

const state = {};

const getters = {};

const actions = {
  index({ commit }, params) {
    return Service.SPExtend.index(params.payload).then((res) => {
      return checkAndReturn(params, res);
    });
  },

  show({ commit }, params) {
    return Service.SPExtend.show(params.payload).then((res) => {
      return checkAndReturn(params, res);
    });
  },

  create({ commit }, params) {
    return Service.SPExtend.create(params.payload).then((res) => {
      return checkAndReturn(params, res);
    });
  },

  createPendingGroup({ commit }, params) {
    return Service.SPExtend.createPendingGroup(params.payload).then((res) => {
      return checkAndReturn(params, res);
    });
  },

  store({ commit }, data) {
    return Service.SPExtend.store(data.payload).then((res) => {
      return checkAndReturn(data, res);
    });
  },

  edit({ commit }, data) {
    return Service.SPExtend.edit(data.payload).then((res) => {
      return checkAndReturn(data, res);
    });
  },

  update({ commit }, data) {
    return Service.SPExtend.update(data.payload).then((res) => {
      return checkAndReturn(data, res);
    });
  },

  delete({ commit }, data) {
    return Service.SPExtend.delete(data.payload).then((res) => {
      return checkAndReturn(data, res);
    });
  },
};

const mutations = {};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
